
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
outline-styled-text-baseline{
  --body-color:var(--brand-white);
}

:host{
  display:block;
  transform:translateY(-2px);
}

.media-gallery-caption{
  display:flex;
  background-color:var(--brand-primary-dark-blue);
  color:var(--brand-white);
}

.media-gallery-caption.inline{
  padding:var(--spacing-12);
  padding:var(--media-gallery-caption-padding, var(--spacing-12));
  flex-direction:column;
}

@media (min-width: 1024px){

.media-gallery-caption.inline{
    align-items:center;
    flex-direction:row
}
  }

.media-gallery-caption.stacked{
  flex-direction:column;
  padding:0 var(--spacing-20);
}

.media-gallery-caption.stacked hr{
    display:none;
  }

.heading{
  display:flex;
  align-items:center;
}

.description{
  font-size:1.375rem;
  line-height:1.5;
  text-align:left;
}

@media (min-width: 1024px){

.inline hr{
      display:none
  }
    }

@media (min-width: 1024px){

.inline .description{
      border-left:0.1875rem solid var(--brand-green-900);
      height:100%;
      padding-left:var(--spacing-16);
      margin-left:var(--spacing-16)
  }
    }

hr{
  border-radius:8px;
  border-radius:var(--ruled-border-radius, 8px);
  border:solid var(--brand-green-900);
  border-width:8px 0 0;
  border-width:var(--ruled-border-width, 8px) 0 0;
  display:block;
  height:0.0625rem;
  max-width:5.3125rem;
  max-width:var(--ruled-max-width, 5.3125rem);
  padding:0;
  position:relative;
  text-align:left;
  width:100%;
  margin-top:var(--spacing-2);
  margin-bottom:var(--spacing-4);
  margin-left:0;
}
`;